import CreateEditOffer from '../pages/offers/CreateEditOffer';
import CreateEditLandingPage from '../pages/landing-pages/CreateEditLandingPage';
import CreateEditPostback from '../pages/postbacks/CreateEditPostback';
import CreateEditConversionType from '../pages/conversion-types/CreateEditConversionType';
import CreateEditFlow from '../pages/flows/CreateEditFlow';
import CreateEditRuleGroup from '../pages/flows/CreateEditRuleGroup';
import CreateEditTSIntegration from '../pages/ts-integrations/CreateEditTSIntegration';
import CreateEditTag from '../pages/tags/CreateEditTag';
import CreateEditAlertChannel from '../pages/alert-channels/CreateEditAlertChannel';

export default function AutoModals() {
  return (
    <>
      <CreateEditOffer />
      <CreateEditLandingPage />
      <CreateEditPostback />
      <CreateEditConversionType />
      <CreateEditFlow />
      <CreateEditRuleGroup />
      <CreateEditTSIntegration />
      <CreateEditTag />
      <CreateEditAlertChannel />
    </>
  );
}
